import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private deferredPrompt: any = null;
  public canPromptInstall = false;

  constructor(private platform: Platform) {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.canPromptInstall = true;
    });

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.canPromptInstall = false;
      console.log('PWA installed');
    });
  }

  async promptInstall(): Promise<void> {
    if (!this.deferredPrompt) {
      return;
    }

    this.deferredPrompt.prompt();
    const choiceResult = await this.deferredPrompt.userChoice;
    console.log('User install choice:', choiceResult.outcome);

    this.deferredPrompt = null;
    this.canPromptInstall = false;
  }
}
